module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form donation-form",
    attrs: {
      "id": "donate-form"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.isLoading),
      expression: "donation.isLoading"
    }],
    staticClass: "wwf-overlay loading"
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.isFailed),
      expression: "donation.isFailed"
    }],
    staticClass: "wwf-overlay processing"
  }, [_c('div', {
    staticClass: "processing-title"
  }, [_vm._v("\n      Unable to process donation, please try again\n    ")])]), _vm._v(" "), _c('Stepper', {
    attrs: {
      "thankYouUrl": _vm.thankYouUrl,
      "useProductThankYouUrl": _vm.useProductThankYouUrl,
      "blacklistUrl": _vm.blacklistUrl,
      "showBequest": _vm.showBequest,
      "showInLovingMemory": _vm.showInLovingMemory,
      "customOnLeft": _vm.customOnLeft,
      "twoDollarLink": _vm.twoDollarLink,
      "donateOnceLink": _vm.donateOnceLink,
      "defaultCustom": _vm.defaultCustom,
      "marketingEmail": _vm.marketingEmail,
      "showPhone": _vm.showPhone,
      "isPhoneMandatory": _vm.isPhoneMandatory
    },
    on: {
      "reset": _vm.reset
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-loading"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76d7f167","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/donation/Donate.vue
// module id = 824
// module chunks = 0